import clsx from 'clsx';

import ArrowLeftIcon from '~/icons/chevron-left.svg';
import ArrowRightIcon from '~/icons/chevron-right.svg';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import { Icon } from '../../Icon/Icon';
import { VisuallyHidden } from '../../VisuallyHidden/VisuallyHidden';
import styles from '../Carousel.module.css';

export type CarouselControlsProps = {
	prevRef?: React.RefObject<HTMLButtonElement>;
	nextRef?: React.RefObject<HTMLButtonElement>;
	className?: string;
};

export const CarouselControls = ({ className, prevRef, nextRef }: CarouselControlsProps) => {
	const { translate } = useTranslation();

	return (
		<div className={clsx(styles.controlsWrapper, className)}>
			<button
				ref={prevRef}
				role="button"
				className={styles.controlButton}
			>
				<Icon size="lg">
					<ArrowLeftIcon />
				</Icon>
				<VisuallyHidden>{translate('accessibility.carousel-previous')}</VisuallyHidden>
			</button>
			<button
				ref={nextRef}
				role="button"
				className={styles.controlButton}
			>
				<Icon size="lg">
					<ArrowRightIcon />
				</Icon>
				<VisuallyHidden>{translate('accessibility.carousel-next')}</VisuallyHidden>
			</button>
		</div>
	);
};
